var _path, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2525 12.0056H13.2901C13.2901 15.1408 13.2901 19 13.2901 19H10.3823C10.3823 19 10.3823 15.1782 10.3823 12.0056H9V9.53354H10.3823V7.93458C10.3823 6.78942 10.9264 5 13.3168 5L15.4716 5.00826V7.40791C15.4716 7.40791 14.1622 7.40791 13.9077 7.40791C13.6531 7.40791 13.2911 7.53521 13.2911 8.08131V9.53403H15.5066L15.2525 12.0056Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 5,
    width: 7,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2525 12.0056H13.2901C13.2901 15.1408 13.2901 19 13.2901 19H10.3823C10.3823 19 10.3823 15.1782 10.3823 12.0056H9V9.53354H10.3823V7.93458C10.3823 6.78942 10.9264 5 13.3168 5L15.4716 5.00826V7.40791C15.4716 7.40791 14.1622 7.40791 13.9077 7.40791C13.6531 7.40791 13.2911 7.53521 13.2911 8.08131V9.53403H15.5066L15.2525 12.0056Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6d791bce.svg";
export { ForwardRef as ReactComponent };